import { Box, Tab } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TabList from '@mui/lab/TabList';
import TabContext from '@mui/lab/TabContext';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../store/rootReducer';
import TabPanel from '@mui/lab/TabPanel';
import { setActiveTab } from '../../../../../../../store/brand/childOfferBrandSlice';
import { OfferComments } from '../../../../../../../shared/components/offer/offer-comments/OfferComments';
import IdeaContent from '../../../offer/modal/tabs/idea/IdeaContent';
import EnhancedAudienceData from '../../../offer/modal/tabs/audience/EnhancedAudienceData';
import { Reviews } from '../../../offer/modal/tabs/reviews/Reviews';
import HistoryDetail from '../../../offer/modal/tabs/history/HistoryDetail';
import { ChildOffer } from '../tabs/offer/ChildOffer';

function ChildOfferModalRightSide() {
    const { activeTabModal, campaign, canWriteComment, hasUnreadComments, selectedUser, user } = useSelector(
        (state: IAllStates) => state.childOfferBrand
    );
    const { isClient } = useSelector((state: IAllStates) => state.auth.user);
    const offer = campaign?.offers[0];

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = window.innerWidth <= 700;

    const handleTab = (event: React.SyntheticEvent, newValue: string) => {
        dispatch(setActiveTab(newValue));
    };

    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={activeTabModal}>
                <Box className="mb-md-3 position-sticky">
                    <TabList
                        allowScrollButtonsMobile={isMobile}
                        variant={isMobile ? 'scrollable' : 'fullWidth'}
                        onChange={handleTab}
                        centered
                    >
                        <Tab label={t('brand.campaign.book.offer.modal.offer')} value="0" />
                        <Tab label={t('brand.campaign.book.offer.modal.content')} value="1" />
                        <Tab label={t('brand.campaign.book.offer.modal.audience')} value="2" />
                        {!isClient && <Tab label={t('brand.campaign.book.offer.modal.reviews')} value="3" />}
                        {!offer?.isLongTerm && (
                            <Tab
                                label={t('brand.campaign.book.offer.modal.comments')}
                                icon={<> {hasUnreadComments && <span className="notification-comment-badge"></span>}</>}
                                value="4"
                            />
                        )}
                        {campaign?.offerPlaceholder?.flags?.hasHistory && (
                            <Tab label={t('brand.campaign.book.offer.modal.history')} value="5" />
                        )}
                    </TabList>
                </Box>
                <Box className="modal-right-content px-md-3">
                    <TabPanel value="0">
                        <ChildOffer />
                    </TabPanel>
                    <TabPanel value="1">
                        <IdeaContent user={selectedUser} campaign={campaign} />
                    </TabPanel>
                    <TabPanel value="2">
                        <EnhancedAudienceData activeTabModal={activeTabModal} userId={selectedUser?.id} user={user} />
                    </TabPanel>
                    {!isClient && (
                        <TabPanel value="3">
                            <Reviews userId={selectedUser?.id} />
                        </TabPanel>
                    )}
                    {!offer?.isLongTerm && (
                        <TabPanel className="h-100" value="4">
                            <OfferComments canWriteComment={canWriteComment} offerId={campaign?.offers[0]?.id ?? 0} />
                        </TabPanel>
                    )}
                    {campaign?.offerPlaceholder?.flags?.hasHistory && (
                        <TabPanel value="5">
                            <HistoryDetail />
                        </TabPanel>
                    )}
                </Box>
            </TabContext>
        </Box>
    );
}

export default ChildOfferModalRightSide;
